import * as React from 'react'
import { FC } from 'react'

import { getStyles } from './useStyles'

import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import { useTheme } from '@mui/material/styles'

export const Footer: FC = () => {
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.footerContainer}>
      <Typography component="span" sx={styles.copyright}>
        Copyright 2020 &copy;
      </Typography>
      <Link
        sx={styles.terms}
        variant="body2"
        href="https://www.workwave.com/terms-of-use/"
        underline="none"
      >
        Terms of Use
      </Link>
      <Link
        sx={styles.privacyPolicy}
        variant="body2"
        href="https://www.workwave.com/privacy-policy/"
        underline="none"
      >
        Privacy Policy
      </Link>
      <Link
        sx={styles.endLife}
        variant="body2"
        href="https://www.workwave.com/end-of-life-policy/"
        underline="none"
      >
        End of Life Policy
      </Link>
    </Box>
  )
}
Footer.displayName = 'Footer'
